import { useMediaQuery } from './useMediaQuery';

/** Matches antd's own breakpoint scale so `shared/ui` and antd's `Grid` agree on when things
 *  switch (docs/PLAN.md §6: Table ↔ cards at 768px, Sider ↔ Drawer at 992px). */
export function useBreakpoint() {
  const isMdUp = useMediaQuery('(min-width: 768px)');
  const isLgUp = useMediaQuery('(min-width: 992px)');
  return {
    isMobile: !isMdUp,
    isMdUp,
    isLgUp,
  };
}
